<template>
  <div
    @click="updateCategory(category)"
    class="TopicCategory btn"
    :class="[getCategory === category ? 'active' : '']"
  >
    <span class="desktopTitle">{{ title }}</span>
    <span class="mobileTitle">{{ mobileTitle }}</span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'TopicsCategoriesButton',
  props: {
    category: String,
    title: String,
    mobileTitle: String,
  },
  methods: {
    ...mapActions(['updateCategory']),
  },
  computed: {
    ...mapGetters(['getCategory']),
  },
};
</script>

<style lang="scss" scoped>
.TopicCategory {
  transition: all 0.4 ease-out;
  &.btn {
    font-weight: 500;
  }
  &.active {
    color: $color-purple;
    transition: all 0.4 ease-out;
  }
}

.mobileTitle {
  display: none;
}

@media screen and (max-width: 1200px) {
  .TopicCategory {
    span {
      font-size: 15px;
    }
    &.btn {
      padding: 7px 12px;
    }
  }
}

@media screen and (max-width: 650px) {
  .TopicCategory {
    span {
      font-size: 15px;
    }
    &.btn {
      padding: 7px 15px;
    }
  }
  .desktopTitle {
    display: none;
  }
  .mobileTitle {
    display: inline-block;
  }
}
</style>
